import BasicDataTable from "../../Component/BasicComponents/BasicDataTable";
import { useState } from "react";
import RouteModal from "../../Component/BasicComponents/Modal/RouteModal";
import { FaEdit } from "react-icons/fa";
import PageHeader from "../../Component/BasicComponents/HeaderBreadCrumbs";
import FileModalContent from "./ModalContent/FileModalContent";
import { useAddFile, useFilesList, useUpdateFile } from "./hooks/useMaterial";
import { showToast } from "../../utils/toastUtils";
type Props = {};

const fileDataColumns = (handleEditFiles: (row: any) => void) => [
  {
    name: "Name",
    selector: (row: { Name: string }) => row?.Name || "-",
    sortable: true,
    wrap: true,
    minWidth: "150px",
  },
  {
    name: "Description",
    selector: (row: { Description: string }) => row.Description || "-",
    sortable: true,
    wrap: true,
    minWidth: "150px",
  },
  {
    name: "URL",
    selector: (row: { Url: string }) => row?.Url || "-",
    sortable: true,
    wrap: true,
    minWidth: "150px",
  },
  {
    name: "Created At",
    selector: (row: { CreatedAt: string }) =>
      row.CreatedAt.split(".")[0] || "-",
    sortable: true,
    wrap: true,
    minWidth: "150px",
  },
  {
    name: "Action",
    cell: (row: any) => (
      <button
        onClick={() => handleEditFiles(row)}
        className="btn btn-primary d-flex align-items-center justify-content-center gap-1"
        style={{ borderRadius: "20px", padding: "3px", width: "70px" }}
      >
        <FaEdit size={14} style={{ fill: "#fff" }} /> Edit
      </button>
    ),
  },
];

const Files = (props: Props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editModalStatus, setEditModalStatus] = useState("");
  const [rowSelected, setRowSelected] = useState(null);
  const [fileID, setFileID] = useState<string | number | undefined>();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formValues, setFormValues] = useState({
    name: "",
    folder: "",
    orgunit: [],
    grade: [],
    description: "",
    url: "",
    media: "",
    page:1,
    length:10,
    search:''
  }); 

  const { data: filesListData ,isLoading:filesListDataLoading} = useFilesList({
    params: {
      page:formValues.page, 
      length:formValues.length,
      ...(formValues.search ===""?{}:{search:formValues.search}),
      ...(formValues.grade.length == 0?{}:{grade:formValues.grade}) 
      },
    enable: true,
  });

  // const { data: filesListData, isLoading: filesListDataLoading } = useFilesList(
  //   {
  //     params: {
  //       page: filtersState?.page,
  //       limit: filtersState?.limit,
  //       search: filtersState?.search,
  //       grade: "",
  //     },
  //     enable: true,
  //   }
  // );

  console.log(
    "🚀 ~ Files.tsx:88 ~ Files ~ filesListData:",
    filesListData?.data?.pagination?.total_records
  );

  const { mutate: addFile } = useAddFile();
  const { mutate: updateFile } = useUpdateFile();

  const handleSubmit = () => {
    if (editModalStatus === "Edit") {
      const selectedGrades = formValues?.grade.map((item: any) => {
        return item?.id;
      });
      const selectedOrgunit = formValues?.orgunit.map((item: any) => {
        return item?.id;
      });
      if (
        !formValues?.name ||
        !formValues?.folder ||
        !formValues?.media ||
        selectedOrgunit.length === 0 ||
        selectedGrades.length === 0
      ) {
        showToast.warning(
          "Please Fill the Required Fields ( Name , Folder , Media )"
        );
        return;
      } else {
        setIsSubmitting(true);
        const updateFileBody = {
          Name: formValues?.name,
          Description: formValues?.description,
          Url: formValues?.url,
          FolderId: formValues?.folder,
          MediaId: formValues?.media,
          Orgunitids: selectedOrgunit,
          Grade: selectedGrades,
        };
        updateFile(
          { id: fileID, body: updateFileBody },
          {
            onSuccess: () => {
              handleClose();
            },
            onError: () => {
              console.log("Error Getting !");
            },
          }
        );
      }
    } else {
      const selectedGrades = formValues?.grade.map((item: any) => {
        return item?.id;
      });
      const selectedOrgunit = formValues?.orgunit.map((item: any) => {
        return item?.id;
      });
      if (
        !formValues?.name ||
        !formValues?.folder ||
        !formValues?.media ||
        selectedOrgunit.length === 0 ||
        selectedGrades.length === 0
      ) {
        showToast.warning(
          "Please Fill the Required Fields ( Name , Folder , Media )"
        );
        return;
      } else {
        setIsSubmitting(true);
        const addFileBody = {
          Name: formValues?.name,
          Description: formValues?.description,
          Url: formValues?.url,
          FolderId: formValues?.folder,
          MediaId: formValues?.media,
          Orgunitids: selectedOrgunit,
          Grade: selectedGrades,
        };

        addFile(
          { body: addFileBody },
          {
            onSuccess: () => {
              handleClose();
            },
            onError: () => {
              console.log("Error Getting !");
            },
          }
        );
      }
    }
  };

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
    setEditModalStatus("");
    setRowSelected(null); // <-- ADD THIS
    setFormValues({
      name: "",
      folder: "",
      orgunit: [],
      grade: [],
      description: "",
      url: "",
      media: "",
      page:1,
      length:10,
      search:''
    });
    setIsSubmitting(false);
  };
  const handleClose = () => {
    setIsModalOpen(false);
    setEditModalStatus("");
    setRowSelected(null); // <-- ADD THIS
    setFormValues({
      name: "",
      folder: "",
      orgunit: [],
      grade: [],
      description: "",
      url: "",
      media: "",
      page:1,
      length:10,
      search:''
    });
    setIsSubmitting(false);
  };

  const handlePagination = (pageNo: number) => {
    setFormValues((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
      };
    });
  };
  const handleonChangeRowsPerPage = (limit: any, pageNo: any) => {
    setFormValues((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
        length: limit,
      };
    });
  };

  const handleSearch = (searchValue: any) => {
    setFormValues((prevState: any) => {
      return {
        ...prevState,
        search: searchValue,
      };
    });
  };

  const handleEditFiles = (row: any) => {
    setEditModalStatus("Edit");
    setIsModalOpen(!isModalOpen);
    setRowSelected(row);
    setFileID(row?.Id);
  };

 console.log('filesListData?.data?.data',filesListData?.data?.pagination?.total_records)

  return (
    <div className="p-2">
      <PageHeader
        title="Files"
        buttons={[
          {
            label: "+ Add Document",
            onClick: toggleModal,
            color: "#2e8dd3",
          },
          {
            label: "Excel",
            onClick: () => alert("Action 2 clicked"),
            color: "#43B9B2",
          },
        ]}
      />

      <BasicDataTable
        Title="File Management"
        data={filesListData?.data?.data || []}
        columns={fileDataColumns(handleEditFiles)}
        dynamicHeightOnRowsPerPage={true}
        showSpinner={filesListDataLoading}
          onChangePage={(pageNo: number) => {
            handlePagination(pageNo);
          }}
          onChangeRowsPerPage={(newPerPage: any, page: any) => {
            handleonChangeRowsPerPage(newPerPage, page);
          }}
          handleSearch={(val:any)=>handleSearch(val)}
          paginationTotalRows={filesListData?.data?.pagination?.total_records || 0}
      />

      <RouteModal
        isOpen={isModalOpen}
        toggle={toggleModal}
        title={editModalStatus === "Edit" ? "Edit Document" : "Add Document"}
        size="md"
        content={
          <FileModalContent
            handleSubmit={handleSubmit}
            handleClose={handleClose}
            setFormValues={setFormValues}
            formValues={formValues}
            editModalStatus={editModalStatus}
            rowSelected={rowSelected}
            isSubmitting={isSubmitting} // ✅ pass
            setIsSubmitting={setIsSubmitting}
          />
        }
      />
    </div>
  );
};

export default Files;
